export default __webpack_public_path__ + "static/media/mini-farb-und-dini.bba253bd.pdf";